export const OperationAttrName = 'operation';
